
// Vue
import { Component } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { Route, RawLocation } from 'vue-router';

// Components
import BasePage from '@/pages/BasePage.vue';
import ProductDetailDescription from '@/pages/ProductDetailDescription.vue';
import ProductDetailEndpoint from '@/pages/ProductDetailEndpoint.vue';
import ProductDetailPackage from '@/pages/ProductDetailPackage.vue';
import ProductDetailPrice from '@/pages/ProductDetailPrice.vue';
import ProductDetailFAQ from '@/pages/ProductDetailFAQ.vue';
import ProductDetailTOS from '@/pages/ProductDetailTOS.vue';

import { TosType } from '@/common/consts';

// CMS
import { Product as ProductContent } from '@/apis/cms';

Component.registerHooks(['beforeRouteEnter']);

/**
 * [SFR0003] 商品詳細ページコンポーネント
 */
@Component({
  components: {
    'detail-description': ProductDetailDescription,
    'detail-endpoint': ProductDetailEndpoint,
    'detail-package': ProductDetailPackage,
    'detail-price': ProductDetailPrice,
    'detail-faq': ProductDetailFAQ,
    'detail-tos': ProductDetailTOS
  }
})
export default class ProductDetailPage extends Mixins<BasePage>(BasePage) {
  /** プロダクトID **/
  private productId = '';

  /** コンテンツ */
  private content: ProductContent = {} as ProductContent;

  private swaggerURL = '';

  /** 概要が開いているか閉じているか */
  private opened: boolean = false;

  /** 選択中のタブ */
  private selectedTab: number = -1;

  /** 概要のテキストエリア高さ */
  private textareaHeight: string = '0px';

  private hasTos(): boolean {
    return this.content.tosType !== TosType.None;
  }

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: RawLocation | ((vm: ProductDetailPage) => any) | void) => void
  ) {
    // URL から productId を取得・保持
    next((vm: ProductDetailPage) => {
      vm.productId = to.params.product_id;
      return;
    });

    next();
  }

  async created() {
    // CMS API呼び出し
    const cmsHttpClient = await this.$cmsClient();
    const limit = 999;
    const id = this.productId || "''";
    const filters = `id[equals]${id}[or]storeCoreProductId[equals]${id}`;
    const products = await cmsHttpClient.product
      .getProducts(limit, undefined, undefined, '', filters)
      .then(res => {
        const { data } = res;
        return data;
      });
    if (products.contents.length === 0) {
      const msg: any = this.$t(
        'pages.productDetailPage.message.productNotFound'
      );
      this.showErrorMessage(msg);
    }
    this.content = products.contents[0];
    if (this.content.swagger) {
      // SwaggerのURLがMicroCMSに登録されたメディアかを確認(保険的改竄防止措置)
      this.swaggerURL =
        this.content.swagger.url &&
        this.content.swagger.url.startsWith('https://files.microcms-assets.io')
          ? this.content.swagger.url
          : '';
    }
  }
  async mounted() {
    // タブ選択
    if (this.$route.query.tab !== undefined) {
      this.selectedTab = Number(this.$route.query.tab);
    } else {
      this.selectedTab = 0;
    }
  }

  /** 概要の表示切り替えボタンに表示するテキストを返す */
  get btnText() {
    return this.$t(
      `pages.productDetailPage.label.${
        this.opened ? 'descriptionResetButton' : 'descriptionFullButton'
      }`
    );
  }

  /** テキストエリア用のstyle（高さの可変対応） */
  get textareaStyles() {
    return {
      '--height': `${this.textareaHeight}`
    };
  }

  /** InHouse かを判定する */
  private isInHouseAPI() {
    return (
      this.content && this.content.type && this.content.type[0] === 'InHouseAPI'
    );
  }
}
